export enum Configuration {
  BANKING_TERMS_DISCLOSURES_URL = "banking-terms-disclosures-url",
  ELECTRONIC_TERMS_DISCLOSURES_URL = "electronic-banking-terms-disclosures-url",
  TISA_URL = "tisa-url",
  ORIGINAL_TISA_URL = "original-tisa-url",
  PRIVACY_NOTICE_URL = "privacy-notice-url",
  PRIVACY_POLICY_URL = "privacy-policy-url",
  ESIGN_URL = "esign-url",
  TERMS_DISCLOSURES_URL = "terms-disclosures-url",
  CUSTOMER_SUPPORT_PHONE = "customer-support-phone",
  PRIVACY_SECURITY_CENTER_URL = "privacy-security-center-url",
}
